import React, {useEffect, useMemo, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {KTSVG} from '../../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {getUserData} from '../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {GeneralDataOFLoginUser} from '../../../../Utils/Auth'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import {
  DeletePriceRateSuperAdmin,
  GetPriceRuleList,
  UpdateCommisionRateSuperAdmin,
} from './GlobalRateCardSlice/GlobalRateCardSlice'
import AddNewPriceRule from './modal/AddNewPriceRule'
import {GetAllAccountId, getAccountIdList} from '../../AllCellCastUser/UserListSlice/UserListSlice'
import Select from 'react-select'
import NodataYet from '../../../../Components/NodataYet'

const GlobalRateCardList = () => {
  const param: any = useLocation()

  const loginUserAccountId = GeneralDataOFLoginUser()?.accountId
  const Role = GeneralDataOFLoginUser()?.role
  const isUserWhiteLabel = GeneralDataOFLoginUser()?.isWhiteLabelUser === true
  const accountIdList = useSelector(getAccountIdList)

  const [bundlePopup, setBundlePopup] = useState(false)
  const [percentage, setPercentage] = useState()
  const [confirm, setConfirm] = useState<any>(false)
  const [getPriceRuleByAccountId, setGetPriceRuleByAccountId] = useState(loginUserAccountId)
  const [open, setOpen] = useState(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const [edit, setEdit] = useState<any>({})
  const PriceRateList = useSelector((state: any) => state?.priceRules?.RateCardList)

  const stafflist = useSelector((state: any) => state?.StaffAccount?.staffAccountList?.items)

  const dispatch = useDispatch()

  const CreateNewPriceRule = useMemo(
    () => (
      <AddNewPriceRule
        data={edit}
        accId={getPriceRuleByAccountId}
        show={bundlePopup}
        handleClose={() => setBundlePopup(false)}
      />
    ),
    [bundlePopup]
  )

  useEffect(() => {
    if (confirm == true) {
      dispatch(
        DeletePriceRateSuperAdmin({
          id: deleteIds,
          accId: getPriceRuleByAccountId,
        })
      )
      setConfirm(false)
    }
  }, [confirm])

  useEffect(() => {
    dispatch(GetPriceRuleList({accountId: getPriceRuleByAccountId}))
  }, [getPriceRuleByAccountId])

  useEffect(() => {
    if (!isUserWhiteLabel) {
      dispatch(GetAllAccountId())
    }
  }, [])
  const handleDelete = (id: any) => {
    setOpen(true)
    setDeleteIds(id)
  }
  const handleEdit = (data: any) => {
    setEdit(data)
    setBundlePopup(true)
  }

  const DeleteConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete this price?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  const updateComission = () => {
    dispatch(
      UpdateCommisionRateSuperAdmin({
        userId: param?.state?.[0]?._id,
        commissionRate: percentage,
      })
    )
  }
  return (
    <>
      {DeleteConfirmation}
      {CreateNewPriceRule}
      <div className='card mb-0 pt-7'>
        <div className='card-header border-bottom-0'>
          <div className='card-title d-flex align-items-center'>
            <h3 className='fw-bolder m-0 text-gray-800'>Price Rules</h3>
          </div>
          <div className='card-toolbar m-0 flex-nowrap'>
            {!isUserWhiteLabel && (
              <Select
                onChange={(e: any) => setGetPriceRuleByAccountId(e.value)}
                options={accountIdList?.map((key: any, index: any) => ({
                  value: `${key?._id}`,
                  label: `${key?.companyName}`,
                }))}
              />
            )}

            {param?.pathname == '/setting/global_ratecard' &&
              AuthenticateUser('create-pricerules') && (
                <div className='d-flex gap-3 align-items-center ms-3'>
                  <button
                    onClick={() => {
                      setBundlePopup(true)
                      setEdit({})
                    }}
                    className='btn btn-primary'
                  >
                    Create
                  </button>
                </div>
              )}

            {param?.pathname == '/staff-profile' &&
              Role == 'superAdmin' &&
              (param?.state?.[0]?.role == 'sales' || param?.state?.[0]?.role == 'staffAdmin') && (
                <div className='d-flex gap-3 align-items-center'>
                  <input
                    className='form-control-solid form-control form-control-sm'
                    name='percentage'
                    value={percentage}
                    onChange={(e: any) => setPercentage(e.target.value)}
                  />
                  <button onClick={updateComission} className='btn btn-primary'>
                    Update
                  </button>
                </div>
              )}
          </div>
        </div>
        {PriceRateList?.length > 0 ? (
          <div className='card-body pt-2'>
            <div className='tab-content'>
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold text-muted text-uppercase'>
                      <th>Type</th>
                      <th>Credit From</th>
                      <th>Credit TO</th>
                      {param?.pathname !== '/staff-profile/credits' && <th>Cost price</th>}
                      <th>Final Price</th>
                      {param?.pathname !== '/setting/global_ratecard' && <th>commission</th>}
                      {Role == 'superAdmin' && param?.pathname == '/setting/global_ratecard' && (
                        <th className='text-center'>Actions</th>
                      )}
                    </tr>
                  </thead>
                  <tbody className='text-gray-600'>
                    {PriceRateList?.map((data: any, id: number) => (
                      <tr key={id}>
                        <td>
                          <span className='badge badge-light-info'>{data?.type}</span>
                        </td>
                        <td>{data?.creditstartrange}</td>
                        <td>{data?.creditendrange}</td>

                        <td>${data?.actualPrice}</td>

                        <td>${data?.finalPrice}</td>

                        {param?.pathname == '/setting/global_ratecard' && (
                          <td className='text-center'>
                            {AuthenticateUser('edit-pricerules') && (
                              <span
                                onClick={() => handleEdit(data)}
                                className='btn btn-bg-light btn-active-color-primary btn-sm'
                              >
                                Edit
                              </span>
                            )}
                            {AuthenticateUser('delete-pricerules') && (
                              <span
                                onClick={() => handleDelete(data?._id)}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-3'
                              >
                                <KTSVG
                                  path='/media/icons/duotune/general/gen027.svg'
                                  className='svg-icon-3'
                                />
                              </span>
                            )}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <NodataYet />
        )}
      </div>
    </>
  )
}

export default GlobalRateCardList
